import { render, staticRenderFns } from "./PopupWindow.vue?vue&type=template&id=4dfab799"
import script from "./PopupWindow.vue?vue&type=script&lang=js"
export * from "./PopupWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports